<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <textarea v-if="!isPosted" rows="5" cols="80" :id="id" :value="value"
              ref="text"
              @input="$emit('input', $event.target.value)"
              class="form-control"></textarea>
  <div v-else>
    <textarea rows="5" cols="80" :id="id" :value="value"
              ref="text"
              @input="$emit('input', $event.target.value)"
              class="form-control" :class="isValidClass"></textarea>
    <div v-if="warningField" :class="validFeedbackClass">
      <fa-icon icon="angle-up"/>
      {{ warningText }}
    </div>
  </div>
</template>

<script>
import { API_WARN_FIELDS, API_POSTED } from '@/store/api/postStatus.types'

export default {
  props: {
    id: { type: String, default: null },
    value: {type: String, required: false},
    field: {type: String, required: false, default: ''},
    focused: {type: Boolean, required: false, default: false}
  },

  directives: {
    focus: {
      inserted: (el) => {
        el.focus()
      }
    }
  },

  mounted () {
    if (this.focused) {
      this.$refs.text.focus()
    }
  },

  methods: {
    getWarningField () {
      return this.$store.getters[API_WARN_FIELDS].find(field => {
        return (Object.keys(field)[0] === this.field)
      })
    }
  },

  computed: {
    warningField () {
      return this.getWarningField()
    },

    warningText () {
      let warning = this.getWarningField()
      if (warning) {
        return warning[Object.keys(warning)[0]]
      } else {
        return ''
      }
    },

    validFeedbackClass () {
      if (this.getWarningField()) {
        return 'invalid-feedback'
      } else {
        return 'valid-feedback'
      }
    },

    isValidClass () {
      if (this.getWarningField()) {
        return 'is-invalid'
      } else {
        // return 'is-valid'
        return ''
      }
    },

    isPosted () {
      return this.$store.getters[API_POSTED]
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/inputs/TextAreaInput.vue